import axios from 'axios';
import { API_URL } from '../config';

const getBaseUrl = () => {
  if (API_URL) {
    const clean = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;
    return `${clean}/careparva-report`;
  }
  return '/careparva-report';
};

const apiClient = axios.create();

apiClient.interceptors.request.use((config) => {
  config.baseURL = getBaseUrl();
  const crmToken = localStorage.getItem('authToken');
  if (crmToken) {
    config.headers.Authorization = `Bearer ${crmToken.trim()}`;
  }
  return config;
});

const careparvaReportService = {
  getBaseUrl,

  // Upload file (Excel .xlsx / .xls or CSV .csv)
  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await apiClient.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  },

  // Get paginated entries
  getEntries: async (params = {}) => {
    const res = await apiClient.get('/entries', { params });
    return res.data;
  },

  // Get single entry by id
  getEntryById: async (id) => {
    const res = await apiClient.get(`/entry/${id}`);
    return res.data;
  },

  // Get summary counts
  getSummary: async () => {
    const res = await apiClient.get('/summary');
    return res.data;
  },

  // Get status update history for a specific unique_id
  getStatusHistory: async (uniqueId) => {
    const res = await apiClient.get(`/status/${encodeURIComponent(uniqueId)}`);
    return res.data;
  },

  // Get upload logs
  getLogs: async (params = {}) => {
    const res = await apiClient.get('/logs', { params });
    return res.data;
  },
};

export default careparvaReportService;

